/* global google */
import { createContext } from 'react';

export interface GoogleMapsProviderContext {
  maps: typeof google.maps | null;
  isLoaded(): boolean;
}

export const GoogleMapsContext = createContext<GoogleMapsProviderContext>({
  maps: null,
  isLoaded: () => false,
});
